// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function CartProductTaxTableCell(props) {
  let formattedTaxAmount = I18n.currencyFormat(undefined, "EUR", 3, 3, props.taxAmount);
  let formattedTaxRate = I18n.percentFormat(undefined, undefined, 1, props.taxRate / 100);
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsx(TextStyle.make, {
        children: formattedTaxAmount
      }),
      JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("order_cart.table.vat_total_column.product_tax_cell.subtext") + " " + formattedTaxRate,
        variation: "normal",
        size: "xxsmall"
      })
    ],
    space: "xsmall"
  });
}

let make = React.memo(CartProductTaxTableCell);

export {
  make,
}
/* make Not a pure module */
